import { TspType } from '@entities/tsp'
import { themeByCSSVariables } from '@shared/lib/theme'

export const getSelectDenominationButtonIconColor = (tspType: TspType | undefined, colorSubcategory?: string) => {
  if (tspType === TspType.KEYS) {
    return themeByCSSVariables.colors.icon.accent
  }

  return `#${colorSubcategory}`
}
